import {
  useDeleteNulls,
} from '@sttedra_ui/framework';

import ComposeUserComposableModel from './use-compose-user.view-model';

import useDecodeJWT from '../decode-jwt';

const {decodeJWT} = useDecodeJWT();

function composeUser({
  isLogged,
  token,
}) {
  let data = null;

  if (isLogged) {
    const decodeToken = decodeJWT(token);

    if (!decodeToken) return null;

    data = new ComposeUserComposableModel(decodeToken);
    useDeleteNulls(data);
  }

  return data;
}

const result = Object.freeze({
  composeUser,
});

export default function() {
  return result;
}
